export default __webpack_public_path__ + "static/media/be-2.9ad2af2b.jpg";